export default "__VITE_ASSET__e2f1cba5__"